import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["type"];
import { jsx as _jsx } from "react/jsx-runtime";
import 'antd/es/skeleton/style';
import DescriptionsPageSkeleton, { DescriptionsSkeleton, TableItemSkeleton, TableSkeleton } from './component/Descriptions';
import ListPageSkeleton, { ListSkeleton, ListSkeletonItem, ListToolbarSkeleton, PageHeaderSkeleton } from './component/List';
import ResultPageSkeleton from './component/Result';

var PageSkeleton = function PageSkeleton(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'list' : _ref$type,
      rest = _objectWithoutProperties(_ref, _excluded);

  if (type === 'result') {
    return _jsx(ResultPageSkeleton, _objectSpread({}, rest));
  }

  if (type === 'descriptions') {
    return _jsx(DescriptionsPageSkeleton, _objectSpread({}, rest));
  }

  return _jsx(ListPageSkeleton, _objectSpread({}, rest));
};

export { ListPageSkeleton, ListSkeleton, ListSkeletonItem, PageHeaderSkeleton, ListToolbarSkeleton, DescriptionsSkeleton, TableSkeleton, TableItemSkeleton };
export default PageSkeleton;